import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from './stores/auth'
import { useTariffInfoStore } from './stores/tariffInfo'
import { gate } from './utils/gate'

const routes = [
  { path: '/login', component: () => import('./views/Login.vue'), meta: { public: true } },
  { path: '/forgot-password', component: () => import('./views/ForgotPassword.vue'), meta: { public: true } },
  { path: '/reset-password', component: () => import('./views/ResetPassword.vue'), meta: { public: true } },
  { path: '/legal/:doc', component: () => import('./views/LegalDocument.vue'), meta: { public: true } },
  { path: '/', component: () => import('./views/Dashboard.vue') },
  // Личный кабинет мастера: свои записи, график, клиенты (только чтение)
  { path: '/my', component: () => import('./views/MasterCabinet.vue'), meta: { requiresAuth: true } },
  
  // === SETTINGS с под-роутами ===
{
  path: '/settings',
  component: () => import('./views/settings/SettingsLayout.vue'),
  meta: { requiresAuth: true },
  children: [
    { path: '', redirect: '/settings/services' },
    { path: 'services', component: () => import('./views/settings/ServicesMastersSchedule.vue') },
    { path: 'masters', component: () => import('./views/settings/ServicesMastersSchedule.vue') },
    { path: 'schedule', component: () => import('./views/settings/ServicesMastersSchedule.vue') },
    { path: 'materials', redirect: '/inventory' },
    { path: 'profile', component: () => import('./views/settings/CompanyProfile.vue') },
    { path: 'booking-mode', component: () => import('./views/settings/BookingSettings.vue') },
    { path: 'waitlist', component: gate('waitlist', () => import('./views/settings/BookingSettings.vue')) },
    { path: 'deposit', component: gate('loyalty_deposits', () => import('./views/settings/DepositSettings.vue')) },
    { path: 'loyalty', component: gate('loyalty_deposits', () => import('./views/settings/LoyaltySettings.vue')) },
    { path: 'referrals', component: gate('loyalty_deposits', () => import('./views/settings/Referrals.vue')) },
    { path: 'resources', component: gate('resource_planning', () => import('./views/settings/Resources.vue')) },
    // MAX и WhatsApp теперь вкладки раздела «Уведомления»
    { path: 'whatsapp', redirect: '/settings/notifications?tab=whatsapp' },
    { path: 'max', redirect: '/settings/notifications?tab=max' },
    { path: 'notifications', component: () => import('./views/settings/Notifications.vue') },
    { path: 'automations', component: () => import('./views/settings/Automations.vue') },
    { path: 'price-adjustments', component: () => import('./views/settings/PriceAdjustments.vue') },
    { path: 'site', component: () => import('./views/settings/Site.vue') },
    { path: 'connections', component: () => import('./views/settings/Connections.vue') },
    { path: 'calendars', component: gate('calendar_sync', () => import('./views/settings/Integrations.vue')) },
    { path: 'privacy', component: () => import('./views/settings/Privacy.vue') },
  ]
},
  
  { path: '/prefs/:id/:key', component: () => import('./views/PrefsPage.vue'), meta: { public: true } },
  { path: '/visit/:id/:key', component: () => import('./views/VisitLive.vue'), meta: { public: true } },
  { path: '/widget/:company_id', component: () => import('./views/Widget.vue'), meta: { public: true } },
  {
    path: '/booking/cancel/:token',
    name: 'PublicCancel',
    component: () => import('./views/PublicCancel.vue'),
    meta: { public: true }
  },
  {
    path: '/booking/reschedule/:token',
    name: 'PublicReschedule',
    component: () => import('./views/PublicReschedule.vue'),
    meta: { public: true }
  },
  {
    path: '/analytics',
    component: () => import('./views/Analytics.vue'),
    meta: { requiresAuth: true, feature: 'analytics_extended' }
  },
  {
    path: '/inventory',
    component: () => import('./views/Inventory.vue'),
    meta: { requiresAuth: true, feature: 'tools_pack' }
  },
  {
    path: '/reports/impact',
    component: () => import('./views/Impact.vue'),
    meta: { requiresAuth: true, feature: 'analytics_extended' }
  },
  {
    path: '/reports/plan-fact',
    component: () => import('./views/PlanFact.vue'),
    meta: { requiresAuth: true, feature: 'analytics_extended' }
  },
  {
    path: '/resources-day',
    component: () => import('./views/ResourceDay.vue'),
    meta: { requiresAuth: true, feature: 'resource_planning' }
  },
  {
    path: '/payroll',
    component: () => import('./views/Payroll.vue'),
    meta: { requiresAuth: true, feature: 'analytics_extended' }
  },
  {
    path: '/clients',
    component: () => import('./views/Clients.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/waitlist-offer/:id',
    name: 'WaitlistOffer',
    component: () => import('./views/WaitlistOffer.vue'),
    meta: { public: true }
  },
  {
    path: '/waitlist/accept/:token',
    name: 'WaitlistAccept',
    component: () => import('./views/WaitlistAccept.vue'),
    meta: { public: true }
  },
  {
    path: '/waitlist/decline/:token',
    name: 'WaitlistDecline',
    component: () => import('./views/WaitlistDecline.vue'),
    meta: { public: true }
  },
  {
    path: '/privacy/:company_id',
    name: 'PrivacyPolicy',
    component: () => import('./views/PrivacyPolicy.vue'),
    meta: { public: true }
  }, 
    {
    path: '/superadmin/login',
    name: 'SuperAdminLogin',
    component: () => import('./views/SuperAdminLogin.vue'),
    meta: { public: true }
  },
  {
  path: '/superadmin/invoices',
  redirect: '/superadmin'
},
  {
    path: '/superadmin',
    name: 'SuperAdminDashboard',
    component: () => import('./views/SuperAdminDashboard.vue'),
    meta: { requiresAuth: false }
  }, 
  {
  path: '/superadmin/invoices',
  redirect: '/superadmin'
},
  {
    path: '/feature-locked',
    name: 'FeatureLocked',
    component: () => import('./views/FeatureLocked.vue'),
    meta: { requiresAuth: true }
  },
  {
  path: '/pricing',
  name: 'Pricing',
  component: () => import('./views/Pricing.vue'),
  meta: { public: true }
  },  
  {
    path: '/payment/success',
    name: 'PaymentSuccess',
    component: () => import('./views/PaymentSuccess.vue'),
    meta: { public: true }
  },
  {
    path: '/payment/fail',
    name: 'PaymentFail',
    component: () => import('./views/PaymentFail.vue'),
    meta: { public: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore()
  
  // === СНАЧАЛА: защита супер-админ роутов ===
  if (to.path.startsWith('/superadmin') && to.path !== '/superadmin/login') {
    const superadminToken = localStorage.getItem('superadmin_token')
    if (!superadminToken) {
      next('/superadmin/login')
      return
    }
    // Супер-админ залогинен — пропускаем, не проверяем обычную авторизацию
    next()
    return
  }
  
  // === ПОТОМ: защита обычных роутов ===
  if (!to.meta.public && !auth.isLoggedIn) {
    next('/login')
    return
  }

  // === Роль «мастер»: только личный кабинет ===
  if (auth.isLoggedIn && auth.isMaster && !to.meta.public && to.path !== '/my') {
    next('/my')
    return
  }
  // Администратор в кабинет мастера не заходит
  if (auth.isLoggedIn && !auth.isMaster && to.path === '/my') {
    next('/')
    return
  }

  // Разделы, входящие в тариф: без функции показываем страницу с предложением сменить тариф
  if (to.meta.feature && auth.isLoggedIn) {
    const tariff = useTariffInfoStore()
    await tariff.load()
    if (!tariff.has(to.meta.feature)) {
      next({ path: '/feature-locked', query: { feature: to.meta.feature } })
      return
    }
  }
  next()
})

export default router